const giftReturnsMessages = {
  giftCard: {
    description:
      'Permite a los destinatarios devolver o cambiar productos que han recibido como regalo. Estas solicitudes nunca serán instantáneas, y el único método de reembolso disponible será tarjeta regalo.',
    alert: 'se emitirán como gift card.',
  },
  storeCredit: {
    description:
      'Permite a los destinatarios devolver o cambiar productos que han recibido como regalo. Estas solicitudes nunca serán instantáneas, y el único método de reembolso disponible será el crédito en tienda.',
    alert: 'se emitirán como crédito en tienda.',
  },
}

export const getGiftReturnsMessages = giftCardAllowed => {
  if (giftCardAllowed) return giftReturnsMessages.giftCard

  return giftReturnsMessages.storeCredit
}
